import { BordBadge } from 'bord-design-system';
import { truncateText } from 'utils/truncateText';
import './QuoteProductPill.scss';

interface IQuoteProductPill {
  label: string;
}

/**
 * Pill reutilizable para mostrar una especificación de producto dentro del módulo QuoteEditor.
 */
const QuoteProductPill = ({ label }: IQuoteProductPill) => (
  <BordBadge className="quoteProductPill" label={truncateText(label, 20)} variant="default" size="small" color="informative" />
);

export default QuoteProductPill;
